import type { MUUID } from 'uuid-mongodb'

import * as z from 'zod'

function isUuid(value: unknown): value is MUUID {
  return (
    (typeof value === 'object' || typeof value === 'string') &&
    value !== null &&
    typeof value.toString === 'function'
  )
}

export const VALIDATE_DB_OUTPUT = import.meta.env?.DEV ?? false
export const VALIDATE_DB_INPUT = import.meta.env?.DEV ?? false

export const latitudeSchema = z.number().min(-90).max(90)
export const longitudeSchema = z.number().min(-180).max(180)
export const positionSchema = z.tuple([longitudeSchema, latitudeSchema])
export const idSchema = z.custom<MUUID>(isUuid)
export const tidSchema = z.string().length(8).regex(/^[0-9a-fA-F]{8}$/)
